import {JourneyTrack} from '../journey-track';
import {TrackInfo} from '../model/track-info';
import {TrackTypes} from '../model/track-types';
import {TrackActionResult} from "../model/track-action-result";

export class ExpTrack implements JourneyTrack {
  track = [
    new TrackInfo('document-type', ['personal-data', 'document-type']),
    new TrackInfo('document-name', ['personal-data', 'document-name']),
    new TrackInfo('document-number', ['personal-data', 'document-number']),
    new TrackInfo('document-issuing', ['personal-data', 'document-issuing']),
    new TrackInfo('parentage', ['personal-data', 'parentage']),
    new TrackInfo('nationality', ['personal-data', 'nationality']),
    new TrackInfo('marital-status', ['marital-status', 'marital-status']),
    new TrackInfo('cep', ['address', 'cep']),
    new TrackInfo('address-name', ['address', 'name']),
    new TrackInfo('address-number', ['address', 'number']),
    new TrackInfo('address-adjunt', ['address', 'adjunt']),
    new TrackInfo('district', ['address', 'district']),
    new TrackInfo('address-state', ['address', 'state']),
    new TrackInfo('address-city', ['address', 'city']),
    new TrackInfo('profession', ['professional-data', 'profession']),
    new TrackInfo('income-wealthincome', ['income', 'income-wealthincome']),
  ];

  getName(): TrackTypes {
    return TrackTypes.EXPERIMENTATION;
  }

  loadData(){
    return Promise.resolve();
  }
  
  getTrack(): TrackInfo[] {
    return this.track;
  }

  executeAction(actionName, data): TrackActionResult {
    return undefined;
  }

  isUncoupled() {
    return false;
  }

  getIndexPage(pageId: string, path: string): number {
    return 0;
  }

  getTotalPage(path: string): number {
    return 0;
  }

  isEventComunicator() {
    return false;
  }

  isBackHeader() {
    return false;
  }

}
